import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Badge, Form, Table,Button } from 'react-bootstrap';
import Footer from '../layout/Footer';
import Icon from '@mdi/react';
import {
    mdiCurrencyRupee,
    mdiCalendarToday,
    mdiAccountGroup,
    mdiLeaf,
    mdiShieldCheck,
    mdiPercent,
    mdiInformationVariantCircle,
} from '@mdi/js';
import { Link } from 'react-router-dom';

// Datatable
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import DataTable from 'datatables.net-dt';
import FormModal from '../../Utils/FormModal';
import { getFromAPI, putToAPI, deleteFromAPI, formatISODateWithTimezone, postToAPI,getProfessionTax } from '../../Utils/utils';
import { toast } from 'react-toastify';
import messages from '../../Utils/lang';
import { isDisabled } from '@testing-library/user-event/dist/utils';

export default function PayRollAdmin() {
    // Modal state
    const isStaffId = Number(localStorage.getItem('loggedInStaffId'));
    const [payrollStaffData1,setPayrollStaffData1] = useState([]);
    // Payroll staff data state (ensuring it's an array)
    const [payrollStaffData, setPayrollStaffData] = useState([]);
    const [totalData,setTotalData] = useState([]);
    const [activeTab, setActiveTab] = useState('payroll');
    const [payRollEmployeeInfo, setPayRollEmployeeInfo] = useState(false);
    const handlePayRollEmployeeInfoShow = () => setPayRollEmployeeInfo(true);
    // State for the selected month filter
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // Default to current month (1-12)
    // const handlePayRollEmployeeInfoClose = () => setPayRollEmployeeInfo(false);
    const [payRollInfo, setPayRollInfo] = useState(false);
    const handlePayRollInfoShow = () => setPayRollInfo(true);
    const handlePayRollInfoClose = () => {
        setPayRollInfo(false);
    };
    
    const handlePayRollEmployeeInfoClose = () => {
        setPayRollEmployeeInfo(false);
    };

    // Store the selected payroll detail ID when editing
    const [selectedPayrollDetailId, setSelectedPayrollDetailId] = useState(null);

    // Input data for the edit modal
    const [inputData, setInputData] = useState({
        firstname: "",
        email: "",
        phonenumber: "",
        staffid: "",
        basic_salary: 0.0,
        gross_salary : 0.0,
        hra: 0.0,
        gratuity: 0.0,
        net_salary: 0.0,
        reimbursements : 0.0,
        conveynace_allowance : 0.0,
        telephone_allowance : 0.0,
        income_tax_tds : 0.0,
        pf : 0.0,
        profession_tax : 0.0,
        medical_allowance : 0.0,
        created_at: formatISODateWithTimezone(new Date()),
        updated_at: formatISODateWithTimezone(new Date()),
        created_user_id: isStaffId,
        payment_status : "",
        accountNumber : "",
        month : "",
        loss_of_hours : "",
        bonus : "",
        esi: false,
        vpf: false,
        ptCheckbox : false,
        gratuitycheckbox: false,
        deducted_leaves : 0,
        lop_deducted_amount : "",
        per_day_salary : "",
        per_hour_salary : "",
        total_hours_worked : "",
        total_working_days : "",
        joining_month_deduction : "",
        gross_salary_earned : "",
        employee_pf : "",
        employee_esi : "",
        deducted_hours : "",
        deducted_hour_amount : "",
        actual_day_count : "",
        adjusted_working_days : "",
        basic_salary_earned :"",
        top_tracker_hour : 0,
        net_salary : "",
        employer_esi : "",
        employer_vpf : "",
        ctc : "",
    });

    // Month names for display purposes
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Payment status for display purposes
      const paymentStatus = [
       "Pending","Processing","Done"
    ];

    // Fetch payroll staff data from the API
    const fetchPayrollStaffData = async () => {
        try {
            const response = await getFromAPI('get_payroll/');
            // Ensure that response is an array; if not, default to empty array
            setPayrollStaffData(Array.isArray(response.staff_payroll) ? response.staff_payroll : []);
        } catch (error) {
            return null;
        }
    };

    // Fetch payroll staff data from the API
    const fetchPayrollDetailsStaffData = async () => {
        try {
            const response = await getFromAPI('get_payroll_details/');
            // Ensure that response is an array; if not, default to empty array
            setTotalData((response.overall_totals)?response.overall_totals:[]);
            setPayrollStaffData1(Array.isArray(response.staff_payroll) ? response.staff_payroll : []);
        } catch (error) {
            return null;
        }
    };
    
    // Function to fetch ESI option
    const fetchESIOption = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=esi_checked');
            if (response.length > 0) {
                setInputData(prevState => ({
                    ...prevState,
                    esi: response[0]?.value === "1" // Set true if "1", false otherwise
                }));
            }
        } catch (error) {
            return null;
        }
    };

    // Function to fetch VPF option
    const fetchVpfOption = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=vpf_checked');
            if (response.length > 0) {
                setInputData(prevState => ({
                    ...prevState,
                    vpf: response[0]?.value === "1" // Set true if "1", false otherwise
                }));
            }
        } catch (error) {
            return null;
        }
    };

    // Function to fetch Gratuity checkbox state
    const fetchGratuityCheckBox = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=gratuity_checkbox');
            if (response.length > 0) {
                setInputData(prevState => ({
                    ...prevState,
                    gratuitycheckbox: response[0]?.value === "1" // Set true if "1", false otherwise
                }));
            }
        } catch (error) {
            return null;
        }
    };

    // Function to fetch Gratuity checkbox state
    const fetchptCheckBox = async () => {
        try {
            const response = await getFromAPI('FtsOptions/?name=pt');
                if (response.length > 0) {
                    setInputData(prevState => ({
                        ...prevState,
                        ptCheckbox: response[0]?.value === "1" // Set true if "1", false otherwise
                    }));
                }
            } catch (error) {
                return null;
            }
    };
    
    // Ensure these are called in useEffect
    useEffect(() => {
        fetchPayrollStaffData();
        fetchPayrollDetailsStaffData();
        fetchESIOption();
        fetchVpfOption();
        fetchGratuityCheckBox();
        fetchptCheckBox();
    }, []);
        

    // Function to handle checkbox changes
    const handleCheckboxChange = (fieldName) => {
        setInputData((prevData) => ({
            ...prevData,
            [fieldName]: !prevData[fieldName],
        }));
    };

    // Cleanup DataTable on unmount or before reinitializing
    useEffect(() => {
        return () => {
            if ($.fn.dataTable.isDataTable('#payrollEmployeeList')) {
                $('#payrollEmployeeList').DataTable().destroy();
            }
        };
    }, [payrollStaffData]);

    useEffect(() => {
        return () => {
            if ($.fn.dataTable.isDataTable('#payrollList')) {
                $('#payrollList').DataTable().destroy();
            }
        };
    }, [payrollStaffData1]);

    const handleInputChange = (index, field, value) => {
        setInputData((prevData) => {
            const updatedData = { ...prevData };
    
            if (field === "esi") {
                updatedData.esi = value === true || value === "true" || value === "1";
            } else if (field === "vpf") {
                updatedData.vpf = value === true || value === "true" || value === "1";
            } else if (field === "gratuitycheckbox") {
                updatedData.gratuitycheckbox = value === true || value === "true" || value === "1";
            } else if (field === "ptCheckbox") {
                updatedData.ptCheckbox = value === true || value === "true" || value === "1";
            } 
            // else if (field === "gross_salary") {
            //     const grossSalary = parseFloat(value) || 0;
            //     updatedData.profession_tax = getProfessionTax(grossSalary);
            //     updatedData[field] = value;
            // }
            else {
                updatedData[field] = value;
            }
            return updatedData;
        });
    };

    // Handle month selection change
    const handleMonthChange = (e) => {
        const monthValue = e.target.value;
        setSelectedMonth(monthValue ? parseInt(monthValue) : ''); // Empty string for "All Months"
        // The useEffect will automatically re-run and filter the table
    };
    
    const handleEditEmployeeForPayrollDetails = ( staffId, month ) => {
        // Find the employee in payrollStaffData by staffId
        const employee = payrollStaffData1.find(emp => emp.staffid === parseInt(staffId));
    
        if (employee) {
            // If multiple payroll details exist, find the specific payroll detail by month
            let payrollDetail = employee.payroll_details?.find(detail => parseInt(detail.month) === parseInt(month));
    
            // If there's only one payroll detail, default to the first one
            if (!payrollDetail) {
                payrollDetail = employee.payroll_details?.[0] || {};
            }
    
            // Calculate net salary using: basic_salary + hra - deductions - gratuity
            const basicSalary = parseFloat(payrollDetail?.basic_salary || 0.0);
            const hra = parseFloat(payrollDetail?.hra || 0.0);
            const deductions = parseFloat(payrollDetail?.deductions || 0.0);
            const gratuity = parseFloat(payrollDetail?.gratuity || 0.0);
            const reimbursements = parseFloat(payrollDetail?.reimbursements ||0.0);
            const conveynace_allowance = parseFloat(payrollDetail?.conveynace_allowance || 0.0);
            const telephone_allowance = parseFloat(payrollDetail?.telephone_allowance || 0.0);
            const income_tax_tds = parseFloat(payrollDetail?.income_tax_tds || 0.0);
            const pf = parseFloat(payrollDetail?.pf || 0.0);
            const profession_tax = parseFloat(payrollDetail?.profession_tax || 0.0);
            const netSalary = basicSalary + hra - deductions - gratuity;
    
            // Set input data
            setInputData({
                firstname: employee.firstname || "",
                email: employee.email || "",
                phonenumber: employee.phonenumber || "",
                staffid: employee.staffid || "",
                basic_salary: payrollDetail?.basic_salary || "",
                gross_salary : payrollDetail ?.gross_salary || "",
                month: payrollDetail?.month || "", // Use passed month or default to first payroll detail
                hra: payrollDetail?.hra || "",
                deductions: payrollDetail?.deductions || "",
                gratuity: payrollDetail?.gratuity || "",
                reimbursements : payrollDetail?.reimbursements || "",
                conveynace_allowance : payrollDetail?.conveynace_allowance || "",
                gross_salary : payrollDetail?.gross_salary || "",
                telephone_allowance : payrollDetail?.telephone_allowance || "",
                income_tax_tds : payrollDetail?.income_tax_tds || "", 
                medical_allowance : payrollDetail?.medical_allowance || "",
                pf : payrollDetail?.pf || "",
                profession_tax : payrollDetail?.profession_tax || "",
                net_salary: netSalary.toString(),  // Convert to string for the form input
                created_at: formatISODateWithTimezone(new Date()),
                updated_at: formatISODateWithTimezone(new Date()),
                created_user_id: isStaffId,
                payment_status : payrollDetail?.payment_status || "",
                accountNumber : payrollDetail?.accountNumber || "",
                loss_of_hours : payrollDetail?.loss_of_hours || "",
                bonus : payrollDetail?.bonus || 0,
                lop_deducted_amount : payrollDetail?.lop_deducted_amount || "",
                per_day_salary : payrollDetail?.per_day_salary || "",
                per_hour_salary : payrollDetail?.per_hour_salary || "",
                total_hours_worked : payrollDetail?.total_hours_worked || "",
                total_working_days : payrollDetail?.total_working_days || "",
                joining_month_deduction : payrollDetail?.joining_month_deduction || "",
                gross_salary_earned : payrollDetail?.gross_salary_earned || "",
                employee_pf : payrollDetail?.employee_pf || "",
                employee_esi : payrollDetail?.employee_esi || "",
                deducted_hours : payrollDetail?.deducted_hours || "",
                deducted_hour_amount : payrollDetail?.deducted_hour_amount || "",
                actual_day_count : payrollDetail?.actual_day_count || "",
                adjusted_working_days : payrollDetail?.adjusted_working_days || "",
                basic_salary_earned :payrollDetail?.basic_salary_earned || "",
                top_tracker_hour : payrollDetail?.top_tracker_hour || 0,
                net_salary : payrollDetail?.net_salary || "",
                ctc : payrollDetail?.ctc || "",
                employer_esi : payrollDetail?.employee_esi || "",
                employer_vpf : payrollDetail?.employer_vpf || "",
            });
    
            handlePayRollInfoShow();
        }
    };

    const handleEditEmployeeForPayroll = (staffId) => {
        const payrollDetail = payrollStaffData.find(emp => emp.staffid === parseInt(staffId));
    
        if (payrollDetail) {
            // Use the first payroll detail if available, otherwise default to an empty object
            const detail = payrollDetail.payroll_details && payrollDetail.payroll_details.length > 0 
                ? payrollDetail.payroll_details[0] 
                : {};
    
            // Always update inputData, even if payroll_details is empty
            const newInputData = {
                firstname: payrollDetail.firstname || "",
                email: payrollDetail.email || "",
                phonenumber: payrollDetail.phonenumber || "",
                staffid: payrollDetail.staffid || "",
                basic_salary: detail.basic_salary || "",
                gross_salary: detail.gross_salary || "",
                hra: detail.hra || "",
                gratuity: detail.gratuity || "",
                reimbursements: detail.reimbursements || "",
                conveynace_allowance: detail.conveynace_allowance || "",
                telephone_allowance: detail.telephone_allowance || "",
                income_tax_tds: detail.income_tax_tds || "",
                medical_allowance: detail.medical_allowance || "",
                pf: detail.pf || "",
                profession_tax: detail.profession_tax || "",
                created_at: formatISODateWithTimezone(new Date()),
                updated_at: formatISODateWithTimezone(new Date()),
                created_user_id: isStaffId,
                payment_status: detail.payment_status || "",
                accountNumber: detail.accountNumber || "",
                deducted_leaves: detail.deducted_leaves || 0,
                esi: detail.esi !== undefined ? detail.esi === "1" || detail.esi === 1 : inputData.esi,
                vpf: detail.vpf !== undefined ? detail.vpf === "1" || detail.vpf === 1 : inputData.vpf,
                gratuitycheckbox: detail.gratuitycheckbox !== undefined ? detail.gratuitycheckbox === "1" || detail.gratuitycheckbox === 1 : inputData.gratuitycheckbox,
                ptCheckbox : detail.ptCheckbox !== undefined ? detail.ptCheckbox === "1" || detail.ptCheckbox === 1 : inputData.ptCheckbox,
            };
    
            // Update state and ensure modal opens after update
            setInputData(newInputData);
            setTimeout(() => handlePayRollEmployeeInfoShow(), 0); // Use setTimeout to ensure state update is processed
        }
    };

    const handleSaveEditEmpForPayroll = async (e) => {
        if (!inputData.accountNumber) {
            toast.error(messages.payroll.account_number);
            return;
        }

        const stringValue = String(inputData.gross_salary)
        if (stringValue.length > 10){
            toast.error("Please enter the valid gross salary")
            return;
        }
        e.preventDefault();
        try {
            const updatedEmployee = {
                firstname: inputData.firstname,
                email: inputData.email,
                phonenumber: inputData.phonenumber,
                staffId: inputData.staffid,
                payrollDetailId: selectedPayrollDetailId,
                basicSalary: inputData.basic_salary,
                gross_salary: inputData.gross_salary,
                payment_status: parseInt(inputData.payment_status),
                accountNumber: inputData.accountNumber,
                profession_tax: inputData.profession_tax,
                hra: inputData.hra,
                deductions: inputData.deductions,
                gratuity: inputData.gratuity,
                reimbursements: inputData.reimbursements,
                conveynace_allowance: inputData.conveynace_allowance,
                telephone_allowance: inputData.telephone_allowance,
                income_tax_tds: inputData.income_tax_tds,
                medical_allowance: inputData.medical_allowance,
                pf: inputData.pf,
                created_at: formatISODateWithTimezone(new Date()),
                updated_at: formatISODateWithTimezone(new Date()),
                created_user_id: isStaffId,
                esi: inputData.esi ? "1" : "0", // Convert boolean to "1" or "0"
                vpf: inputData.vpf ? "1" : "0", // Convert boolean to "1" or "0"
                gratuitycheckbox: inputData.gratuitycheckbox ? "1" : "0", // Convert boolean to "1" or "0"
                ptCheckbox : inputData.ptCheckbox ? "1" : "0",
                deducted_leaves: inputData.deducted_leaves,
                net_salary: inputData.net_salary,
                ctc: inputData.ctc,
                employer_esi: inputData.employer_esi,
                employer_vpf: inputData.employer_vpf,
            };
            await postToAPI(`save_payroll_details/`, { data: updatedEmployee });
            toast.success(messages.payroll.updated_successfully);
            handlePayRollEmployeeInfoClose();
            fetchPayrollStaffData();
        } catch (error) {
            toast.error(messages.payroll.failed_to_update);
        }
    };

    // Save updated employee info via API call
    const handleSaveEditEmpForPayrollDetails = async (e) => {
        e.preventDefault();
         try {
                if (!inputData.basic_salary) {
                    toast.error(messages.payroll.required_basic_salary);
                    return;
                }
                
                if (!inputData.hra) {
                    toast.error(messages.payroll.required_hra);
                    return;
                }
                
                if(!inputData.month){
                    toast.error(messages.payroll.month);
                    return;
                }
    
                if(!inputData.accountNumber)
                { 
                   toast.error(messages.payroll.account_number);
                  return;
                }

                const updatedEmployee = {
                    firstname: inputData.firstname,
                    email: inputData.email,
                    phonenumber: inputData.phonenumber,
                    staffId: inputData.staffid,
                    gross_salary : inputData.gross_salary,
                    payrollDetailId: selectedPayrollDetailId, // Include the payroll detail ID for updating the correct record
                    basicSalary: inputData.basic_salary,
                    payment_status : parseInt(inputData.payment_status), // Include the payment status in the update
                    accountNumber : inputData.accountNumber,
                    profession_tax : inputData.profession_tax,
                    hra: inputData.hra,
                    month : parseInt(inputData.month),
                    deductions: inputData.deductions,
                    gratuity: inputData.gratuity,
                    reimbursements : inputData.reimbursements,
                    conveynace_allowance : inputData.conveynace_allowance,
                    telephone_allowance : inputData.telephone_allowance,
                    income_tax_tds : inputData.income_tax_tds,
                    medical_allowance: inputData.medical_allowance,
                    pf : inputData.pf,
                    lop_days : inputData.lop_days,
                    created_at: formatISODateWithTimezone(new Date()),
                    updated_at: formatISODateWithTimezone(new Date()),
                    created_user_id: isStaffId,
                    loss_of_hours : inputData.loss_of_hours,
                    bonus : inputData.bonus,
                    lop_deducted_amount : inputData.lop_deducted_amount,
                    per_day_salary : inputData.per_day_salary,
                    per_hour_salary : inputData.per_hour_salary,
                    total_hours_worked : inputData.total_hours_worked,
                    total_working_days : inputData.total_working_days,
                    joining_month_deduction : inputData.joining_month_deduction,
                    gross_salary_earned : inputData.gross_salary_earned,
                    employee_pf : inputData.employee_pf,
                    employee_esi :inputData.employee_esi,
                    deducted_hours : inputData.deducted_hours,
                    deducted_hour_amount :  inputData.deducted_hour_amount,
                    actual_day_count :  inputData.actual_day_count,
                    adjusted_working_days : inputData.adjusted_working_days,
                    basic_salary_earned : inputData.basic_salary_earned,
                    top_tracker_hour : inputData.top_tracker_hour
                };
                
                await postToAPI(`save_payroll_details1/`, { data: updatedEmployee });
                toast.success(messages.payroll.updated_successfully);
                handlePayRollInfoClose();
                fetchPayrollDetailsStaffData();
            } catch (error) {
                toast.error(messages.payroll.failed_to_update);
            }
    };
    
   // handle the fuction for generate the data from payroll to payroll details.
    const handleGenerateButton = async() => {
        try {
            const response = await postToAPI('transfer_payrollDetails/')
            if(response){
                toast.success(messages.payroll.generate_button)
            }
        } catch(error){
            toast.error("Data with this staff id already exist")
        }
    }
   
    DataTable.Buttons.jszip(JSZip);
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    
    useEffect(() => {
        return () => {
            if ($.fn.dataTable.isDataTable('#payrollEmployeeList')) {
                $('#payrollEmployeeList').DataTable().destroy();
            }
        };
    }, []);

    useEffect(() => {
        return () => {
            if ($.fn.dataTable.isDataTable('#payrollList')) {
                $('#payrollList').DataTable().destroy();
            }
        };
    }, []);

    useEffect(() => {
        if (activeTab !== 'payroll') return;

        if ($.fn.dataTable.isDataTable('#payrollEmployeeList')) {
            $('#payrollEmployeeList').DataTable().clear().destroy();
        }

        const tableData = payrollStaffData.flatMap((staff, staffIndex) => {
            const payrollDetails = Array.isArray(staff.payroll_details) ? staff.payroll_details : [];
            
            if (payrollDetails.length === 0) {
                return [[
                    staffIndex + 1,
                    staff.firstname,
                    staff.email,
                    staff.phonenumber,
                    staff.staffid,
                    0.0,
                    0.0,
                    0.0,
                    staff.staffid,
                ]];
            }

            return payrollDetails.map((detail) => [
                staffIndex + 1,
                staff.firstname,
                staff.email,
                staff.phonenumber,
                staff.staffid,
                detail.basic_salary || 0.0,
                detail.hra || 0.0,
                detail.gratuity || 0.0,
                staff.staffid,
            ]);
        });

        $('#payrollEmployeeList').DataTable({
            dom: "flrtip",
            pageLength: 25,
            data: tableData,
            destroy: true,
            columns: [
                { title: '#' },
                { title: 'Name' },
                { title: 'Email' },
                { title: 'Phone' },
                { title: 'Employee ID' },
                { title: 'Basic Salary' },
                { title: 'HRA' },
                { title: 'Gratuity' },
                { 
                    title: 'Action',
                    render: (data, type, row) => {
                        const staffId = row[8];
                        return `<button class="btn btn-info edit-btn" data-staff-id="${staffId}">Edit</button>`;
                    }
                }
            ],
            autoWidth: false,
        });

        const tableBody = document.querySelector('#payrollEmployeeList tbody');
        tableBody?.addEventListener('click', (event) => {
            const editBtn = event.target.closest('.edit-btn');
            if (editBtn) {
                const staffId = editBtn.getAttribute('data-staff-id');
                handleEditEmployeeForPayroll(staffId);
            }
        });

        return () => {
            tableBody?.removeEventListener('click', handleEditEmployeeForPayroll);
        };

    }, [payrollStaffData, activeTab]);

    // Payroll Details DataTable with month filter
    useEffect(() => {
        if (activeTab !== 'payrollDetails') return;

        if ($.fn.dataTable.isDataTable('#payrollList')) {
            $('#payrollList').DataTable().clear().destroy();
        }

        const tableData = payrollStaffData1.flatMap((staff, staffIndex) => {
            const payrollDetails = Array.isArray(staff.payroll_details) ? staff.payroll_details : [];
            return payrollDetails.map((detail) => {
                const monthIndex = parseInt(detail.month, 10) - 1;
                const monthName = monthIndex >= 0 && monthIndex < 12 ? monthNames[monthIndex] : "N/A";
                return [
                    staffIndex + 1,
                    staff.firstname,
                    staff.email,
                    staff.phonenumber,
                    monthName,
                    staff.staffid,
                    detail.basic_salary || 0.0,
                    detail.hra || 0.0,
                    detail.payment_status ? paymentStatus[parseInt(detail.payment_status) - 1] || detail.payment_status : "Pending",
                    detail.gratuity || 0.0,
                    staff.staffid,
                    detail.month, // Keep the numeric month for filtering
                ];
            });
        });

        const table = $('#payrollList').DataTable({
            dom: "flrtip",
            pageLength: 25,
            data: tableData,
            destroy: true,
            columns: [
                { title: '#' },
                { title: 'Name' },
                { title: 'Email' },
                { title: 'Phone' },
                { title: 'Month' },
                { title: 'Employee ID' },
                { title: 'Basic Salary' },
                { title: 'HRA' },
                { title: 'Payment Status' },
                { title: 'Gratuity' },
                {
                    title: 'Action',
                    render: (data, type, row) => {
                        const staffId = row[10];
                        const month = row[11];
                        return `<button class="btn btn-info edit-btn" data-staff-id="${staffId}" data-month-id="${month}">Edit</button>`;
                    }
                }
            ],
            autoWidth: false,
            // Add custom filtering for the month
            initComplete: function () {
                this.api()
                    .column(4) // Month column index
                    .search(selectedMonth ? `^${monthNames[selectedMonth - 1]}$` : '', true, false)
                    .draw();
            }
        });

        const tableBody = document.querySelector('#payrollList tbody');
        tableBody?.addEventListener('click', (event) => {
            const editBtn = event.target.closest('.edit-btn');
            if (editBtn) {
                const staffId = editBtn.getAttribute('data-staff-id');
                const month = editBtn.getAttribute('data-month-id');
                handleEditEmployeeForPayrollDetails(staffId, month);
            }
        });

        return () => {
            tableBody?.removeEventListener('click', handleEditEmployeeForPayrollDetails);
        };
    }, [payrollStaffData1, activeTab, selectedMonth]); 
    
   // Rows for the FormModal
   const rows1 = [
    {
        columns: [
            { size: { lg: 6 }, label: <span>Employee Name <span style={{ color: 'red' }}>*</span></span>, type: 'text', name: 'firstname', id: 'firstname', placeholder: 'Enter employee name...', value: inputData.firstname, errormsg: '', readOnly: true,disabled:true },
            { size: { lg: 6 }, label: <span>Email <span style={{ color: 'red' }}>*</span></span>, type: 'email', name: 'email', id: 'email', placeholder: 'Enter email...', value: inputData.email, errormsg: '', readOnly: true,disabled:true },
            { size: { lg: 6 }, label: <span>Mobile No <span style={{ color: 'red' }}>*</span></span>, type: 'number', name: 'phonenumber', id: 'phonenumber', placeholder: 'Enter mobile number...', value: inputData.phonenumber, errormsg: '', readOnly: true,disabled:true },
            { size: { lg: 6 }, label: <span>Account Number <span style={{ color: 'red' }}>*</span></span>, type: 'number', name: 'accountNumber', id: 'accountNumber', placeholder: 'Enter Account Number...', value: inputData.accountNumber, errormsg: '', onChange: (e) => handleInputChange('accountNumber', e.target.value) },
            { size: { lg: 6 }, label: <span>Gross Salary <span style={{ color: 'red' }}>*</span></span>, type: 'number', name: 'gross_salary', id: 'gross_salary', placeholder: 'Enter Gross Salary...', value: inputData.gross_salary, errormsg: '', onChange: (e) => handleInputChange('gross_salary', e.target.value) },
            // Deducted Leaves Input Field (Set based on joining date)
            { size: { lg: 6 }, 
              label: "Deducted Leaves according to joining date", 
              type: 'number', 
              name: 'deducted_leaves', 
              id: 'deducted_leaves', 
              placeholder: 'Enter deducted leaves according to joining date...', 
              value: inputData.deducted_leaves, 
              errormsg: '', 
              onChange: (e) => handleInputChange('deducted_leaves', e.target.value)
            },
            {
                size: { lg: 3 },
                type: "checkboxes",
                checkboxes: [
                    { name: "esi", id: "esi", checked: inputData.esi, label: "ESI", onChange: () => handleInputChange(null, "esi", !inputData.esi) },
                ],
            },
            {
                size: { lg: 3 },
                type: "checkboxes",
                checkboxes: [
                    { name: "vpf", id: "vpf", checked: inputData.vpf, label: "VPF", onChange: () => handleInputChange(null, "vpf", !inputData.vpf) },
                ],
            },
            {
                size: { lg: 3 },
                type: "checkboxes",
                checkboxes: [
                    { name: "gratuitycheckbox", id: "gratuitycheckbox", checked: inputData.gratuitycheckbox, label: "Gratuity", onChange: () => handleInputChange(null, "gratuitycheckbox", !inputData.gratuitycheckbox) },
                ],
            },
            {
                size: { lg: 3 },
                type: "checkboxes",
                checkboxes: [
                    { name: "ptCheckbox", id: "ptCheckbox", checked: inputData.ptCheckbox, label: "Profession Tax", onChange: () => handleInputChange(null, "ptCheckbox", !inputData.ptCheckbox) },
                ],
            },
           
        ]
      }
   ];

    // Rows for the FormModal
    const rows = [
        {
            columns: [
                { size: { lg: 6 }, label: <span>Employee Name <span style={{ color: 'red' }}>*</span></span>, type: 'text', name: 'firstname', id: 'firstname', placeholder: 'Enter employee name...', value: inputData.firstname, errormsg: '', readOnly: true,disabled:true},
                { size: { lg: 6 }, label: <span>Email <span style={{ color: 'red' }}>*</span></span>, type: 'email', name: 'email', id: 'email', placeholder: 'Enter email...', value: inputData.email, errormsg: '', readOnly: true,disabled:true },
                { size: { lg: 6 }, label: <span>Mobile No <span style={{ color: 'red' }}>*</span></span>, type: 'number', name: 'phonenumber', id: 'phonenumber', placeholder: 'Enter mobile number...', value: inputData.phonenumber, errormsg: '', readOnly: true,disabled:true },
                { size: { lg: 6 }, label: <span>Account Number <span style={{ color: 'red' }}>*</span></span>, type: 'number', name: 'accountNumber', id: 'accountNumber', placeholder: 'Enter Account Number...', value: inputData.accountNumber, errormsg: '', onChange: (e) => handleInputChange('accountNumber', e.target.value),disabled:true},
                { 
                    size: { lg: 6 }, 
                    label: <span>Month <span style={{ color: 'red' }}>*</span></span>, 
                    type: 'select', 
                    name: 'month', 
                    id: 'month', 
                    value: inputData.month, 
                    onChange: (e) => handleInputChange('month', e.target.value), 
                    errormsg: '', 
                    disabled:true,
                    options: [
                        { value: "", label: "Select Month" },
                        { value: "1", label: "January" },
                        { value: "2", label: "February" },
                        { value: "3", label: "March" },
                        { value: "4", label: "April" },
                        { value: "5", label: "May" },
                        { value: "6", label: "June" },
                        { value: "7", label: "July" },
                        { value: "8", label: "August" },
                        { value: "9", label: "September" },
                        { value: "10", label: "October" },
                        { value: "11", label: "November" },
                        { value: "12", label: "December" }
                    ]
                },
                
                { 
                    size: { lg: 6 }, 
                    label: <span>Payment Status <span style={{ color: 'red' }}>*</span></span>, 
                    type: 'select', 
                    name: 'payment_status', 
                    id: 'payment_status', 
                    value: inputData.payment_status, 
                    onChange: (e) => handleInputChange('payment_status', e.target.value), 
                    errormsg: '', 
                    options: [
                        { value: "", label: "Select Payment Status" },
                        { value: "1", label: "Pending" },
                        { value: "2", label: "Processing" },
                        { value: "3", label: "Done" }
                    ]
                },
                { size: { lg: 6 }, label: "Gross Salary", type: 'number', name: 'gross_salary', id: 'gross_salary', placeholder: 'Enter Gross Salary...', value: inputData.gross_salary, errormsg: '', onChange: (e) => handleInputChange('gross_salary', e.target.value),disabled:true },
                { size: { lg: 6 }, label: <span>Basic Salary<span style={{ color: 'red' }}>*</span></span>, type: 'number', name: 'basic_salary', id: 'basic_salary', placeholder: 'Enter Basic Salary...', value: inputData.basic_salary, errormsg: '', onChange: (e) => handleInputChange('basic_salary', e.target.value),disabled:true },
                { size: { lg: 6 }, label: <span>HRA<span style={{ color: 'red' }}>*</span></span>, type: 'number', name: 'hra', id: 'hra', placeholder: 'Enter HRA...', value: inputData.hra, errormsg: '', onChange: (e) => handleInputChange('hra', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Reimbursement", type: 'number', name: 'reimbursements', id: 'reimbursements', placeholder: 'Enter Reimbursement...', value: inputData.reimbursements, errormsg: '', onChange: (e) => handleInputChange('reimbursements', e.target.value),disabled:true },
                { size: { lg: 6 }, label:" Conveyance Allowance", type: 'number', name: 'conveynace_allowance', id: 'conveynace_allowance', placeholder: 'Enter Conveyance allowance...', value: inputData.conveynace_allowance, errormsg: '', onChange: (e) => handleInputChange('conveynace_allowance', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Telephone Allowance", type: 'number', name: 'telephone_allowance', id: 'telephone_allowance', placeholder: 'Enter Special allowance...', value: inputData.telephone_allowance, errormsg: '', onChange: (e) => handleInputChange('telephone_allowance', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Medical Allowance", type: 'number', name: 'medical_allowance', id: 'medical_allowance', placeholder: 'Enter Medical allowance...', value: inputData.medical_allowance, errormsg: '', onChange: (e) => handleInputChange('medical_allowance', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Income Tax(TDS)", type: 'number', name: 'income_tax_tds', id: 'income_tax_tds', placeholder: 'Enter Income tax tds...', value: inputData.income_tax_tds, errormsg: '', onChange: (e) => handleInputChange('income_tax_tds', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Provident Fund(PF)", type: 'number', name: 'pf', id: 'pf', placeholder: 'Enter Provident Fund...', value: inputData.pf, errormsg: '', onChange: (e) => handleInputChange('pf', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Professional Tax", type: 'number', name: 'profession_tax', id: 'profession_tax', placeholder: 'Enter Professional Tax...', value: inputData.profession_tax, errormsg: '', onChange: (e) => handleInputChange('profession_tax', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Total working days", type: 'number', name: 'total_working_days', id: 'total_working_days', placeholder: 'Enter total working days...', value: inputData.total_working_days, errormsg: '', onChange: (e) => handleInputChange('deducted_hour_amount', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Total days worked", type: 'number', name: 'actual_day_count', id: 'actual_day_count', placeholder: 'Enter total days worked...', value: inputData.actual_day_count, errormsg: '', onChange: (e) => handleInputChange('actual_day_count', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Total hours worked", type: 'number', name: 'total_hours_worked', id: 'total_hours_worked', placeholder: 'Enter total hour worked...', value: inputData.total_hours_worked, errormsg: '', onChange: (e) => handleInputChange('total_hours_worked', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Per day salary", type: 'number', name: 'per_day_salary', id: 'per_day_salary', placeholder: 'Enter per day salary...', value: inputData.per_day_salary, errormsg: '', onChange: (e) => handleInputChange('per_day_salary', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Per hour salary", type: 'number', name: '', id: 'per_hour_salary', placeholder: 'Enter per hour salary...', value: inputData.per_hour_salary, errormsg: '', onChange: (e) => handleInputChange('per_hour_salary', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Deducted hour amount", type: 'number', name: 'deducted_hour_amount', id: 'deducted_hour_amount', placeholder: 'Enter Deducted hour amount...', value: inputData.deducted_hour_amount, errormsg: '', onChange: (e) => handleInputChange('deducted_hour_amount', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "LOP Deducted Amount", type: 'number', name: 'lop_deducted_amount', id: 'lop_deducted_amount', placeholder: 'Enter lop deducted amount...', value: inputData.lop_deducted_amount, errormsg: '', onChange: (e) => handleInputChange('lop_deducted_amount', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Amount leaves deduction according to joining date", type: 'number', name: 'joining_month_deduction', id: 'joining_month_deduction', placeholder: 'Enter joining month deduction...', value: inputData.joining_month_deduction, errormsg: '', onChange: (e) => handleInputChange('joining_month_deduction', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Gross Salary(Salary Earned After LOP)", type: 'number', name: 'gross_salary_earned', id: 'gross_salary_earned', placeholder: 'Enter gross salary earned...', value: inputData.gross_salary_earned, errormsg: '', onChange: (e) => handleInputChange('gross_salary_earned', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Basic", type: 'number', name: 'basic_salary_earned', id: 'basic_salary_earned', placeholder: 'Enter basic salary earned...', value: inputData.basic_salary_earned, errormsg: '', onChange: (e) => handleInputChange('basic_salary_earned', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Employee vpf", type: 'number', name: 'employee_vpf', id: 'employee_vpf', placeholder: 'Enter employee vpf...', value: inputData.employee_pf, errormsg: '', onChange: (e) => handleInputChange('employee_pf', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Employee esi", type: 'number', name: 'employee_esi', id: 'employee_esi', placeholder: 'Enter employee esi...', value: inputData.employee_esi, errormsg: '', onChange: (e) => handleInputChange('employee_esi', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Gratuity", type: 'number', name: 'gratuity', id: 'gratuity', placeholder: 'Enter Gratuity...', value: inputData.gratuity, errormsg: '', onChange: (e) => handleInputChange('gratuity', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Employer esi", type: 'number', name: 'employer_esi', id: 'employer_esi', placeholder: 'Enter employer esi...', value: inputData.employer_esi, errormsg: '', onChange: (e) => handleInputChange('employer_esi', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Employer vpf", type: 'number', name: 'employer_vpf', id: 'employer_vpf', placeholder: 'Enter employer vpf...', value: inputData.employer_vpf, errormsg: '', onChange: (e) => handleInputChange('employer_vpf', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "CTC(monthly)", type: 'number', name: 'ctc', id: 'ctc', placeholder: 'Enter CTC...', value: inputData.ctc, errormsg: '', onChange: (e) => handleInputChange('ctc', e.target.value),disabled:true,readOnly:true },
                { size: { lg: 6 }, label: "Deducted hours", type: 'number', name: 'deducted_hours', id: 'deducted_hours', placeholder: 'Enter deducted hours...', value: inputData.deducted_hours, errormsg: '', onChange: (e) => handleInputChange('deducted_hours', e.target.value),disabled:true },
                { size: { lg: 6 }, label: "Bonus", type: 'number', name: 'bonus', id: 'bonus', placeholder: 'Enter Bonus...', value: inputData.bonus, errormsg: '', onChange: (e) => handleInputChange('bonus', e.target.value) },
                { size: { lg: 6 }, label: "Top Tracker Hour", type: 'number', name: 'top_tracker_hour', id: 'top_tracker_hour', placeholder: 'Enter top tracker hours...', value: inputData.top_tracker_hour, errormsg: '', onChange: (e) => handleInputChange('top_tracker_hour', e.target.value) },
                { size: { lg: 6 }, label: "Net Salary", type: 'number', name: 'net_salary', id: 'net_salary', placeholder: 'Enter net salary...', value: inputData.net_salary, errormsg: '', onChange: (e) => handleInputChange('net_salary', e.target.value),disabled:true },

            ]
        }
    ];

    // Add JavaScript to prevent tampering
    document.querySelectorAll('input[readonly]').forEach(input => {
        input.addEventListener('change', (e) => {
            e.target.value = inputData[e.target.name]; // Revert to original value
        });
    });

    const isValid = () => {
        return (
            inputData.gross_salary &&
            inputData.accountNumber
        )
    }
    // Buttons for the payRollInfo modal
    const Buttons = [
        { variant: "primary", text: "Update", onClick: handleSaveEditEmpForPayrollDetails },
        { variant: "secondary", text: "Cancel", onClick: handlePayRollInfoClose }, // Corrected to match payRollInfo
    ];

    // Buttons for the payRollEmployeeInfo modal
    const Buttons1 = [
        { variant: "primary", text: "Update", onClick: handleSaveEditEmpForPayroll,disabled: !isValid()},
        { variant: "secondary", text: "Cancel", onClick: handlePayRollEmployeeInfoClose }, // Corrected to match payRollEmployeeInfo
    ];
    const handlePaymentStatus = async() => {
        try{
            const response = await postToAPI(`update_payment_status/`)
            if(response){
                toast.success("Payment status updated successfully")
                fetchPayrollDetailsStaffData()
            }
        }
        catch(error){
            toast.error("Error in update")
        }
    };

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col md={12}>
                                <h5 className='mb-4 mt-2'>
                                    {/* Process Pay Run <span className='fw-normal'>01/01/2025 to 31/01/2025</span>
                                    <Badge bg="soft-primary" className='ms-3'>Approved</Badge> */}
                                </h5>
                                <Card>
                                    <Card.Body>
                                        <Row className='align-items-center'>
                                            <Col sm={6} md={4}>
                                                <div className='d-flex align-items-center'>
                                                    <div className='avatar avatar-xl bg-soft-success border border-soft-success text-success'>
                                                        <Icon path={mdiCurrencyRupee} className='avatar-icon' />
                                                    </div>
                                                    <div className='ms-4'>
                                                        <h3 className='mb-1'>₹{totalData?.total_net_salary || 0}</h3>
                                                        <p className='mb-0 fs-16 text-muted'>Employees Net Pay</p>
                                                    </div>
                                                </div>
                                            </Col>
                                            {/* <Col sm={6} md={4}>
                                                <div className='d-flex align-items-center mt-4 mt-sm-0'>
                                                    <div className='avatar avatar-xl bg-soft-primary border border-soft-primary text-primary'>
                                                        <Icon path={mdiCalendarToday} className='avatar-icon' />
                                                    </div>
                                                </div>
                                            </Col> */}
                                            <Col md={4}>
                                                <div className='d-flex align-items-center mt-4 mt-md-0'>
                                                    <div className='avatar avatar-xl bg-soft-info border border-soft-info text-info'>
                                                        <Icon path={mdiAccountGroup} className='avatar-icon' />
                                                    </div>
                                                    <div className='ms-4'>
                                                        <h3 className='mb-1'>{payrollStaffData.length}</h3>
                                                        <p className='mb-0 fs-16 text-muted'>No. Of Employees</p>
                                                    </div>
                                                </div>
                                            </Col>
                                            {/* <Col lg={3} className='text-center text-lg-end mt-lg-0 mt-4'>
                                                <Button variant="primary" size='lg' onClick={handlePayRollAdminDetailsShow}>View Details & Pay</Button>
                                            </Col> */}
                                            <Col md={12}>
                                                <div className='d-flex align-items-center justify-content-between mb-3'>
                                                    {/* <h5 className='mt-3'>Previous Month</h5> */}
                                                    {/* <Form.Select size='sm' className='w-auto'>
                                                        <option value="">Select a month</option>
                                                        <option value="1">January</option>
                                                        <option value="2">February</option>
                                                        <option value="3">March</option>
                                                    </Form.Select> */}
                                                </div>
                                                <Row className='mt-3'>
                                                    <Col xs={12} sm={6} md={4} className='mb-4'>
                                                        <div className='d-flex align-items-center'>
                                                            
                                                            <div className='ms-4'>
                                                                <p className='text-primary mb-1'>Total Basic Salary</p>
                                                                <h4 className='fw-light mb-0'>₹{totalData?.total_basic_salary || 0}</h4>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} sm={6} md={4} className='mb-4'>
                                                        <div className='d-flex align-items-center'>
                                                            
                                                            <div className='ms-4'>
                                                                <p className='text-primary mb-1'>Total HRA</p>
                                                                <h4 className='fw-light mb-0'>₹{totalData?.total_hra || 0}</h4>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} sm={6} md={4} className='mb-3'>
                                                        <div className='d-flex align-items-center'>
                                                        
                                                            <div className='ms-4'>
                                                                <p className='text-primary mb-1'>Total Gratuity</p>
                                                                <h4 className='fw-light mb-0'>₹{totalData?.total_gratuity || 0}</h4>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    
                                                    <Col sm={6} md={4}>
                                                        <div className='d-flex align-items-center'>
                                                           
                                                            <div className='ms-4'>
                                                                <p className='text-primary mb-1'>Total Reimbursement</p>
                                                                <h4 className='fw-light mb-0'>₹{totalData?.total_reimbursements || 0}</h4>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col sm={6} md={4}>
                                                        <div className='d-flex align-items-center'>

                                                            <div className='ms-4'>
                                                                <p className='text-primary mb-1'>Total Conveyance Allowance</p>
                                                                <h4 className='fw-light mb-0'>₹{totalData?.total_conveynace_allowance || 0}</h4>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col sm={6} md={4}>
                                                        <div className='d-flex align-items-center'>
                                                            
                                                            <div className='ms-4'>
                                                                <p className='text-primary mb-1'>Total Telephone Allowance</p>
                                                                <h4 className='fw-light mb-0'>₹{totalData?.total_special_allowance}</h4>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col sm={6} md={4}>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='ms-4'>
                                                                <p className='text-primary mb-1'>Total Professional Tax</p>
                                                                <h4 className='fw-light mb-0'>₹{totalData?.total_profession_tax || 0}</h4>
                                                            </div>
                                                        </div>
                                                    </Col>
                                    
                                                </Row>
                                            </Col>
                                        </Row>
                                        <div className='d-flex align-items-center gap-2 mt-5'>
                                            {/* <Icon path={mdiInformationVariantCircle} className='icon-size-20' /> */}
                                            {/* <p className='text-muted mb-0'>
                                                Pay your employees on 31/01/2025. Record it here once you have made the payment.
                                            </p> */}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Row>
                                <Col md={12} className="mt-4">
                                    <div className="d-flex gap-2">
                                        <Button 
                                            variant={activeTab === "payroll" ? "primary" : "outline-primary"} 
                                            onClick={() =>{
                                                 setActiveTab("payroll")
                                                 fetchPayrollStaffData()
                                            }}
                                        >
                                            Payroll
                                        </Button>
                                        <Button 
                                            variant={activeTab === "payrollDetails" ? "primary" : "outline-primary"} 
                                            onClick={() =>{ 
                                                setActiveTab("payrollDetails")
                                                fetchPayrollDetailsStaffData();
                                            }}
                                         >
                                            Payroll Details
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                                            
                            {/* <Col md={8}>
                                <div className='d-flex flex-wrap gap-3 align-items-center justify-content-between mt-5 mb-3'>
                                    <h5 className='mb-0'>Previous Month</h5>
                                    <Form.Select size='sm' className='w-auto'>
                                        <option value="">Select a month</option>
                                        <option value="1">January</option>
                                        <option value="2">February</option>
                                        <option value="3">March</option>
                                    </Form.Select>
                                </div>
                                <Card>
                                    <Card.Body>
                                        <Row>
                                            <Col sm={4} className='text-center text-sm-start mb-sm-0 mb-5'>
                                                <div className='avatar avatar-lg bg-soft-primary border border-soft-primary text-primary mx-sm-0 mx-auto'>
                                                    <Icon path={mdiLeaf} className='avatar-icon' />
                                                </div>
                                                <p className='text-primary mt-4 mb-sm-4 mb-2'>EPF</p>
                                                <h4 className='mb-sm-4 mb-2 fw-light'>₹15,42,630.00</h4>
                                                <Link to="#">View Details</Link>
                                            </Col>
                                            <Col sm={4} className='text-center text-sm-start mb-sm-0 mb-5'>
                                                <div className='avatar avatar-lg bg-soft-success border border-soft-success text-success mx-sm-0 mx-auto'>
                                                    <Icon path={mdiShieldCheck} className='avatar-icon' />
                                                </div>
                                                <p className='text-success mt-4 mb-sm-4 mb-2'>ESI</p>
                                                <h4 className='mb-sm-4 mb-2 fw-light'>₹60,690.00</h4>
                                                <Link to="#">View Details</Link>
                                            </Col>
                                            <Col sm={4} className='text-center text-sm-start'>
                                                <div className='avatar avatar-lg bg-soft-danger border border-soft-danger text-danger mx-sm-0 mx-auto'>
                                                    <Icon path={mdiPercent} className='avatar-icon' />
                                                </div>
                                                <p className='text-danger mt-4 mb-sm-4 mb-2'>TDS Deduction</p>
                                                <h4 className='mb-sm-4 mb-2 fw-light'>₹8,20,800.00</h4>
                                                <Link to="#">View Details</Link>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col> */}
                            {/* <Col md={4}>
                                <h5 className='mb-3 mb-md-4 pb-md-2 mt-md-5'>Employee Summary</h5>
                                <Card>
                                    <Card.Body className='text-center'>
                                        <p className='text-muted mb-3 mt-4'>Active Employees</p>
                                        <h1 className='mb-4 fw-normal'>{payrollStaffData.length}</h1>
                                        <hr className='w-50 mx-auto' />
                                        <Link to="/branch_admin">View Employees</Link>
                                    </Card.Body>
                                </Card>
                            </Col> */}
                        </Row>

                        {activeTab === "payroll" && (
                        <Row>
                            <Col md={12}>
                                <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
                                     <h5 className="mb-0">Payroll</h5>
                                <Button variant="primary" onClick={handleGenerateButton}>Generate</Button>
                                </div>
                                <Card>
                                    <Card.Body>
                                        <Table responsive bordered className="table-nowrap" id="payrollEmployeeList">
                                            <thead className="table-light"></thead>
                                        </Table>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}

                    {activeTab === "payrollDetails" && (
                            <Row>
                                <Col md={12}>
                                    <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
                                        <h5 className="mb-0">Payroll Details</h5>
                                        <div className="d-flex gap-2 align-items-center">
                                            <Form.Select
                                                size="sm"
                                                value={selectedMonth}
                                                onChange={handleMonthChange}
                                                style={{ width: 'auto' }}
                                            >
                                                <option value="">All Months</option>
                                                {monthNames.map((month, index) => (
                                                    <option key={index} value={index + 1}>
                                                        {month}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Button variant="primary" onClick={handlePaymentStatus}>
                                                Update Payment Status
                                            </Button>
                                        </div>
                                    </div>
                                    <Card>
                                        <Card.Body>
                                            <Table responsive bordered className="table-nowrap" id="payrollList">
                                                <thead className="table-light"></thead>
                                            </Table>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        )}

                    </Container>
                </div>
                <Footer />
            </div>
            <FormModal
                title="Edit Payroll Details"
                formModalShow={payRollInfo}
                Buttons={Buttons}
                handleFormModalClose={handlePayRollInfoClose} // Matches the state
                rows={rows}
                handleInputChange={handleInputChange}
                handleSubmit={handleSaveEditEmpForPayrollDetails}
            />

            <FormModal
                title="Edit Employee Payroll Details"
                formModalShow={payRollEmployeeInfo}
                Buttons={Buttons1}
                handleFormModalClose={handlePayRollEmployeeInfoClose} // Matches the state
                rows={rows1}
                handleInputChange={handleInputChange}
                handleSubmit={handleSaveEditEmpForPayroll}
            />

        </>
    );
}